import React, { Component } from "react";
import $ from 'jquery';

class LiveParticipants extends Component {
  
  constructor(props) {
		super(props);
		this.state={
			participantListOpen: 0,
			currentUserData: JSON.parse(localStorage.getItem('userData')),
		}
	}
 
	componentDidMount(){
		window['showHideStream'] = this.backToDefault;
		window['checkForStreams'] = this.checkForStreams;
		window['hideMembersOnVirtualActivity'] = this.showHideStream;
		window['checkShowUsers'] = this.checkShowUsers;
		
		let participantClosedFromStorage = localStorage.getItem('participantClosedList');
		if ( participantClosedFromStorage )
			{
				this.setState({
					participantListOpen: parseInt(participantClosedFromStorage),
				});
			}
	}
	
	showHideStream=()=>{
		var styleHidden = window.getComputedStyle(document.getElementById('disable_streams'));
		if ( styleHidden.display == 'block' ) { return false; }
		
		var isOpenListVar = this.props.openParticipantList;
		isOpenListVar = !isOpenListVar;
	
		this.props.updateStateFromChild({openParticipantList: isOpenListVar});
		if ( isOpenListVar ) 
			{ 
				window['openParticipantList'] = true;
				window.subscribeVisibleForVideo();
				
				this.setState({
					participantListOpen: 0,
				});
				localStorage.setItem("participantClosedList", 0);
			}
		else 
			{ 
				window['openParticipantList'] = false;
				window.subscribeVisibleForAudio();
				this.setState({
					participantListOpen: 1,
				});	
				localStorage.setItem("participantClosedList", 1);	
			}
			
	}
	
	backToDefault = ()=>{
		this.props.updateStateFromChild({openParticipantList: false});
	}
	
	checkForStreams=()=>{
		if ( this.state.participantListOpen == 0 || this.state.participantListOpen == '0' )
			{
				var isOpenListVar = this.props.openParticipantList;
				if ( !isOpenListVar )
					{
						this.props.updateStateFromChild({openParticipantList: true});
						window['openParticipantList'] = true;
						window.subscribeVisibleForVideo();
					}
					
			}
	}
	
	checkShowUsers=()=>{
		if ( this.props.openParticipantList )
			{
				$('#participants_streams').removeClass('opacityHide');	
			}
	}
	
	render() {
		return (
			<div className="stream_container" id="participants_streams">
				{ !this.state.currentUserData.sessionData.ondemandId &&
					<div id="participantsStreamList" className={"stream_inner " + ( this.props.openParticipantList ? "d-none" : "" ) + (window['zoomedOption'] == 2 ? " stream_inner_zoomed" : "") } onClick={this.showHideStream}>
						<div className="pos_rel" id="numDisplayed" >Live Members <span id="joined_users_at_client"></span></div>
						<div className="pos_rel d-none" id="poorNetworkMsgMembers" >Disabled due to Poor Network</div>   
						<div className="open_arrow"></div>
						<div className="disable_list" id="disable_streams"></div>
					</div>
				}
				<div  id="members_inner_main" className={"open_stream_inner " + ( !this.props.openParticipantList ? "d-none" : "" ) }>
					<div className="hide_stream_text dspl_inl" onClick={this.showHideStream}>Live Members <span id="joined_users_at_client1"></span>
						<div className="close_arrow"></div>
					</div>
					<div id="participant_streams" className="live_participants_scroll"></div>
				</div>
			</div>		
	)}
}
export default LiveParticipants;
